<template lang="pug">
#application-form.bg-blue-500.py-10
  //- .bg-white 
    .container 
      pre redirectLink {{ redirectLink }}
      pre {{ jdDetails.lists }}
  .container.text-center
    .flex-col.py-4.px-2.w-full(class="md:px-4 mdLpt-5")
      h1.text-white.mb-4.text-4xl.font-semibold Apply for {{ jdDetails ? jdDetails.text : "" }}
      p.hidden.text-white.font-sm(class="md:block") {{ submitFormText }}
      .w-full(style="text-align: center" v-if="!isFormSuccess")
        #sib-form-container.sib-form-container.w-full
          #sib-container.sib-container--large.sib-container--vertical.ml-1(style="text-align: center;background-color: rgba(255, 255, 255, 1);")
            form#sib-form(method="POST" name="sib-form" @submit.stop.prevent="() => {return submitSibForm('https://dd98694c.sibforms.com/serve/MUIEAH26PdwASZdbIwAmTd-NMC0ViQaYNej5gqurZZfQd9bbrVm013g9LmCNukBqFtQccgIKnaqkmlFmSHUofx2x9FaUVQ_IHmy1fLZ3ot0shzM52YBGpycuu7cpBYsMzIWNIhUF6FqN5ldPx632A-dHtRlFw1DdV6tgIH1LRdaJS38Su-FUqVQr-pRrHh5oxfkoM89PZiBACo1R' );}")
              .w-full
                .justify-between(class="md:flex")
                  .sib-input.sib-form-block(class="w-full md:w-1/2")
                    .form__entry.entry_block
                      .form__label-row
                        label.entry__label(for="NAME" data-required="*") Name
                        .entry__field
                          input#NAME.input(type="text" name="NAME" autocomplete="off" data-required="true" required="")
                  .sib-input.sib-form-block(class="w-full md:w-1/2")
                    .form__entry.entry_block
                      .form__label-row
                        label.entry__label(for="EMAIL" data-required="*") Email Address
                        .entry__field
                          input#EMAIL.input(type="text" name="EMAIL" autocomplete="off" data-required="true" required="")
                .justify-between.mt-1(class="md:flex md:mt-6")
                  .sib-input.sib-form-block(class="w-full md:w-1/2")
                    .form__entry.entry_block
                      .form__label-row
                        label.entry__label(for="LINKEDIN_OR_GITHUB_PROFILE_LINK") LinkedIn/GitHub Profile Link
                        .entry__field
                          input#LINKEDIN_OR_GITHUB_PROFILE_LINK.input(maxlength="200" type="text" name="LINKEDIN_OR_GITHUB_PROFILE_LINK" autocomplete="off")
                  .sib-input.sib-form-block(class="w-full md:w-1/2")
                    .form__entry.entry_block
                      .form__label-row
                        label.entry__label(for="PHONE_NUMBER") Phone Number
                        .entry__field
                          input#PHONE_NUMBER.input(maxlength="200" type="text" name="PHONE_NUMBER" autocomplete="off")
                div(hidden="")
                  .sib-input.sib-form-block
                    .form__entry.entry_block
                      .form__label-row
                        .entry__field
                          input#JD.input(maxlength="200" type="text" name="JD" autocomplete="off" :data-required="\
                          Object.keys(jdDetails).length ? true : false\
                          " :required="\
                          Object.keys(jdDetails).length ? true : false\
                          " :value="jdDetails.text")
                div(hidden="")
                  .sib-input.sib-form-block
                    .form__entry.entry_block
                      .form__label-row
                        label.entry__label(for="PAGE_URL" data-required="*")
                          | Page URL
                        .entry__field
                          input#PAGE_URL.input(maxlength="200" type="text" name="PAGE_URL" autocomplete="off" :data-required="\
                          Object.keys(jdDetails).length ? true : false\
                          " :required="\
                          Object.keys(jdDetails).length ? true : false\
                          " :value="jdDetails.id")
              .flex.w-full.justify-center.ml-5.mt-4
                p.text-white.mb-0(v-if="isFormError" v-html="errorMessage")
              .flex.w-full.justify-center.mt-6
                .sib-form-block(style="text-align: left")
                  button.sib-form-block__button-with-loader.btn.btn-pink-500.mt-5(form="sib-form" type="submit" :disabled="isSignupDisabled" class="!rounded-sm")
                    svg.icon.clickable__icon.progress-indicator__icon.sib-hide-loader-icon.text-white(viewbox="0 0 512 512")
                      path(d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z")
                    |                         {{ signupText }}
              input#email_address_check.input--hidden(type="text" name="email_address_check" value="")
              input#locale(type="hidden" name="locale" value="en")
      p.text-white(v-else="") {{ successMessage }}
</template>

<script>
export default {
  name: "JobApplicationForm",
  data() {
    return {
      isSignupDisabled: false,
      signupText: "Apply now",
      isFormSuccess: false,
      isFormError: false,
      successMessage: "Thank you for showing interest in working with us. 😃",
      errorMessage: "",
      submitFormText:
        "Fill the form below to kick-start your application. You will be redirected to our job site upon submitting your details.",
    };
  },
  props: {
    jdDetails: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    redirectLink() {
      if (!this.jdDetails) return "";
      if (!this.jdDetails.text.toLowerCase().includes("intern")) return ""; // protect roles not internships
      if (!this.jdDetails.lists) return "";
      const findIndex = this.jdDetails.lists.findIndex(
        (x) => x.text === "redirect"
      );
      if (findIndex === -1) return "";
      return this.jdDetails.lists[findIndex].content
        .replace("<li>", "")
        .replace("</li>", "");
    },
  },
  mounted() {
    let self = this;
    let style = document.createElement("link");
    style.type = "text/css";
    style.rel = "stylesheet";
    style.href = "https://sibforms.com/forms/end-form/build/sib-styles.css";
    document.head.appendChild(style);
  },
  methods: {
    extractLinkFromHTML(htmlString) {
      const regex = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/g;
      const match = regex.exec(htmlString);
      if (match && match[2]) {
        return match[2];
      }
      return null;
    },
    async submitSibForm(formUrl) {
      if (!Object.keys(this.jdDetails).length) return;
      let self = this;
      let formData = new FormData(document.querySelector("#sib-form"));
      let url = `${formUrl}?isAjax=1`;

      try {
        const rawResponse = await fetch(url, {
          method: "POST",
          body: formData,
        });
        const data = await rawResponse.json();
        if (data && data.success === true) {
          self.submitFormText =
            "Great, you're a step closer to completing your application. 🎉";
          self.signupText = "Apply now";
          self.isSignupDisabled = false;
          self.isFormSuccess = true;
          self.isFormError = false;
          self.errorMessage = "";
          const redirectLink = this.redirectLink
            ? this.redirectLink
            : `https://app.careerpuck.com/job-board/atlan/job/${self.jdDetails.id}/`;
          setTimeout(() => {
            window.location.href = redirectLink;
          }, 3000);
        } else {
          self.signupText = "Apply now";
          self.isSignupDisabled = false;
          self.isFormSuccess = false;
          self.isFormError = true;
          self.errorMessage =
            "Sorry, could not process your application. Please try again.";
        }
      } catch (error) {
        let errorObject = error.responseJSON;
        let invalidInformation = false;
        if (
          errorObject &&
          errorObject.errors &&
          Object.keys(errorObject.errors).length
        ) {
          let errorKeys = Object.keys(errorObject.errors);
          for (let keyIndex = 0; keyIndex < errorKeys.length; keyIndex++) {
            if (
              errorObject.errors[errorKeys[keyIndex]].includes(
                "The information provided is invalid. Please review the field format and try again."
              )
            ) {
              invalidInformation = true;
              break;
            }
          }
        }
        self.signupText = "Apply now";
        self.isSignupDisabled = false;
        self.isFormSuccess = false;
        self.isFormError = true;
        if (!invalidInformation) {
          self.errorMessage =
            "Sorry, could not process your application. Please try again later.";
        } else {
          self.errorMessage =
            "The information provided is invalid. Please try again.";
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
#sib-container {
  background: transparent !important;
}

.entry__field input,
.entry__field select {
  padding: 0.5rem;
  height: calc(1.5em + 0.75rem + 2px) !important;
  font-size: 1rem !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #495057 !important;
  background-color: #ffffff !important;
  background-clip: padding-box !important;
  border: none !important;
  border-top-left-radius: 0.12rem !important;
  border-bottom-left-radius: 0.12rem !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  -webkit-transition: border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
  font-family: Avenir, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, Noto Sans, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
  outline: none;
  &:focus {
    outline: 2px solid #cae1f4;
  }
}
.sib-form-block__button-with-loader {
  font-weight: 700 !important;
  line-height: 21px !important;
  border-radius: 6px !important;
}
.entry__label {
  font-size: 13px;
  text-align: left;
  font-weight: 600;
  color: #fff;
}
.entry__error--primary {
  font-size: 12px;
  text-align: left;
  color: #e12d39;
}
.sib-form {
  padding: 0;
}
.entry__label,
label {
  margin-bottom: 3px;
}
</style>
